/* @flow */
import React from 'react';
import Table, {
  THead, TBody, Tr, Th, Td,
} from 'components/UIKit/Table';
import { DynamicEntityLink } from 'components/Links';
import withRouting from 'utils/withRouting';

const RelatedEntitiesList = ({
  children, style, entityId, router,
}) => {
  return (
    <Table style={{ border: '1px solid #e5e5e5', ...style }}>
      <THead>
        <Tr>
          <Th>Category</Th>
          <Th>Type</Th>
          <Th style={{ textAlign: 'right' }}>Count</Th>
        </Tr>
      </THead>
      <TBody>
        {children.map((c) => {
          const LinkComponent = DynamicEntityLink(c.type, "browse");

          return (
            <Tr key={c.type}>
              <Td style={{ textTransform: 'capitalize' }}>{c.category}</Td>
              <Td style={{ textTransform: 'capitalize' }}>{c.type}</Td>
              <Td style={{ textAlign: 'right' }}>
                <LinkComponent query={{ withPathTo: [{ type: 'case', id: entityId }] }}>{c.count}</LinkComponent>
              </Td>
            </Tr>
          );
        })}
      </TBody>
    </Table>
  );
}

export default withRouting(RelatedEntitiesList);